import BasePopup from '../Base/BasePopup';
export default BasePopup;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-tree-select@2.9.1@rc-tree-select/es/Popup/MultiplePopup.js
// module id = 1411
// module chunks = 0